import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";
import Breadcrumb from "./breadcrumb/reducer";

import ui from './ui/reducer';
import auth from './auth/authReducer';
import psychologists from './psychologists/reducer';
import psychologist from './psychologist/reducer';
import consultations from './consultations/consultationsReducer';
import consultation from './consultations/consultationReducer';
import schedulers from './schedulers/reducer';
import users from './users/reducer';
import user from './user/reducer';
import centers from './centers/reducer';
import checkouts from './checkouts/reducer';
import pages from './pages/reducer';
import singlePage from './singlePage/reducer';
import tasks from './tasks/reducer';
import callbacks from './callbacks/reducer';
import feedbacks from './feedbacks/reducer';
import notes from './notes/reducer';
import problems from './problems/reducer';
import prices from './prices/reducer';
import promos from './promos/reducer';
import filters from './filters/reducer';
import agora from './consultations/agoraReducer';
import userCheckoutsHistory from './userCheckoutsHistory/reducer';
import seo from './seo/reducer';
import singleSeoPage from './singleSeoPage/reducer';
import features from './features/reducer';
import banners from './banners/reducer';
import nutrition from './nutrition/reducer';
import specialistProfile from './specialistProfile/reducer';

const rootReducer = combineReducers({
  Layout,
  Breadcrumb,

  ui,
  auth,
  psychologists,
  psychologist,
  consultations,
  consultation,
  schedulers,
  users,
  user,
  centers,
  checkouts,
  pages,
  singlePage,
  tasks,
  callbacks,
  feedbacks,
  notes,
  problems,
  prices,
  promos,
  filters,
  agora,
  userCheckoutsHistory,
  seo,
  singleSeoPage,
  features,
  banners,
  nutrition,
  specialistProfile,
});

export default rootReducer;
